export const TrendData = [
  {
    name: "Minions",
    shares: 97,
  },
  {
    name: "Avengers",
    shares: 80.5,
  },
  {
    name: "BlackPink",
    shares: 75.5,
  },
  {
    name: "Reactjs",
    shares: 72,
  },
  {
    name: "ElonMusk",
    shares: 71.9,
  },
  {
    name: "JurassicWorld",
    shares: 20,
  },
];
